import React from 'react';
import "./Loader.css";

class Loader extends React.Component {
    render() {

        let bg = {
            "display": this.props.isActive ? "grid" : "none",
        };

        return <div className="loader-component" style={bg}>
            <div className="loader"/>
        </div>
    }
}

export default Loader;
